import React from 'react';
import { Link } from 'react-router-dom';
import './MeetTheTeam.css';

const teamMembers = [
    {
        id: 'casey-daggett',
        name: 'Casey C. Daggett',
        title: 'Partner & Principal Attorney',
        image: '/images/casey.png',
        shortBio: 'Experienced attorney specializing in consumer protection and employment law.',
        fullBio: 'Casey C. Daggett, Esq. is the founder of Consumer Equity Legal, a firm built from the ground up with a singular mission: to defend everyday individuals against the widespread manipulation and coercion practiced by modern corporations. Casey is unwavering in his commitment to delivering exceptional legal representation. He ensures that every client receives the attention, respect, and diligence they deserve, and that every case is handled with the highest standard of excellence.',        
        specialties: []
    },
    {
        id: 'bill-petti',
        name: 'Bill Petti',
        title: 'Of Counsel',
        image: '/images/bill.png',
        shortBio: 'Dedicated to helping clients navigate complex business litigation matters.',
        fullBio: 'Bill is an attorney at Consumer Equity Legal, where he leads the White Collar & Regulatory Enforcement Defense practice. He is dedicated to protecting clients facing complex investigations, high-stakes litigation, or civil disputes, bringing a proven record of successful outcomes and strategic advocacy. Bill ensures every client receives focused, diligent representation, navigating the legal process with expertise and a commitment to achieving the best possible results.',
        specialties: []
    },
    {
        id: 'nataly-prado',
        name: 'Nataly Prado',
        title: 'Law Clerk',
        image: '/images/nataly.jpg',
        shortBio: 'Nataly Prado is a Law Clerk at Consumer Equity Legal, where she supports the firm\'s litigation practice. She earned her Bachelor\'s Degree in Political Science from California State University, Northridge in 2016, and went on to receive her Juris Doctor from California Western School of Law in San Diego in 2022. Since graduating, Ms. Prado has concentrated her work in litigation, providing valuable support in case preparation, legal research, and trial strategy.',
        fullBio: 'Nataly Prado is a Law Clerk at Consumer Equity Legal, where she supports the firm\'s litigation practice. She earned her Bachelor\'s Degree in Political Science from California State University, Northridge in 2016, and went on to receive her Juris Doctor from California Western School of Law in San Diego in 2022. Since graduating, Ms. Prado has concentrated her work in litigation, providing valuable support in case preparation, legal research, and trial strategy.',
        specialties: []
    },
    {
        id: 'sam-dickinson',
        name: 'Samuel Dickinson',
        title: 'Legal Assistant',
        image: '/images/sam.jpeg',
        shortBio: 'Samuel is a skilled Legal Assistant here at Consumer Equity Legal. His many duties include organizing and labeling documents, identifying deficiencies in opposing counsels\'s productions, and drafting demand letters and agreements. Samuel may also determine monetary damages in cases and manage phone calls from clients, reaching out to them to gather more information on a case if needed.',
        fullBio: 'Samuel is a skilled Legal Assistant here at Consumer Equity Legal. His many duties include organizing and labeling documents, identifying deficiencies in opposing counsels\'s productions, and drafting demand letters and agreements. Samuel may also determine monetary damages in cases and manage phone calls from clients, reaching out to them to gather more information on a case if needed.',
        specialties: []
    },
    {
        id: 'christian-salazar',
        name: 'Christian Salazar',
        title: 'Software Developer & Data Specialist',
        image: '/images/christian.jpg',
        shortBio: 'Christian serves as the Software Developer and Data Specialist at Consumer Equity Legal, where he builds and maintains the technological infrastructure that supports the firm\'s operations. This includes building and securing the API layer for our Client Intake Form, designing and maintaining the company website, and creating internal tools such as a custom timekeeping portal to automate and streamline daily operations.',
        fullBio: 'Christian serves as the Software Developer and Data Specialist at Consumer Equity Legal, where he builds and maintains the technological infrastructure that supports the firm\'s operations. This includes building and securing the API layer for our Client Intake Form, designing and maintaining the company website, and creating internal tools such as a custom timekeeping portal to automate and streamline daily operations.',
        specialties: []
    },
    {
        id: 'asa-quadri',
        name: 'Asa Quadri',
        title: 'Legal Secretary',
        image: '/images/Asa-Quadri.jpg',
        shortBio: 'Asa serves as the Legal Secretary at Consumer Equity Legal where she provides essential administrative support to the legal team. Her responsibilities include managing schedules, preparing legal documents, and ensuring smooth communication with the firm\'s Clients and Staff.',
        fullBio: 'Asa serves as the Legal Secretary at Consumer Equity Legal where she provides essential administrative support to the legal team. Her responsibilities include managing schedules, preparing legal documents, and ensuring smooth communication with the firm\'s Clients and Staff.',
        specialties: []
    },
    {
        id: 'belle-dolan-carleton',
        name: 'Belle Dolan Carleton',
        title: 'Law Clerk',
        image: '/images/Belle-Carleton.jpg',
        shortBio: 'Belle Dolan Carleton is a Law Clerk at Consumer Equity Legal, where she supports the firm in legal drafting and research. She earned her Bachelor\'s Degree in Psychology from Pepperdine University in 2026, along with a Certificate in Conflict Management from the Straus Institute of Dispute Resolution at Pepperdine Caruso School of Law. Belle is an incoming J.D. candidate at University of San Diego Law. She is passionate about law and being able to serve clients in the Southern California and Inland Empire areas.',
        fullBio: 'Belle Dolan Carleton is a Law Clerk at Consumer Equity Legal, where she supports the firm in legal drafting and research. She earned her Bachelor\'s Degree in Psychology from Pepperdine University in 2026, along with a Certificate in Conflict Management from the Straus Institute of Dispute Resolution at Pepperdine Caruso School of Law. Belle is an incoming J.D. candidate at University of San Diego Law. She is passionate about law and being able to serve clients in the Southern California and Inland Empire areas.',
        specialties: []
    }


];

function MeetTheTeam() {
    return (
        <div className="meet-the-team-container">
            <section className="section team-header-section">
                <h1>Meet The Team</h1>
                <p>Get to know our dedicated legal professionals who are committed to fighting for your rights and delivering exceptional results.</p>
            </section>

            <div className="team-grid">
                {teamMembers.map((member) => (
                    <div key={member.id} className="team-member-card">
                        <div className="team-member-image">
                            <Link to={`/team/${member.id}`} className="image-link" aria-label={`Learn more about ${member.name}`}>
                                <img 
                                    src={member.image} 
                                    alt={member.name}
                                    loading="lazy"
                                />
                            </Link>
                        </div>
                        <div className="team-member-info">
                            <h2>{member.name}</h2>
                            <h3>{member.title}</h3>
                            
                            <div className="bio-content">
                                <p className="bio-text">
                                    {member.fullBio || member.shortBio}
                                </p>
                            </div>

                            {member.specialties && member.specialties.length > 0 && (
                                <div className="specialties">
                                    {member.specialties.map((specialty, index) => (
                                        <span key={index} className="specialty-tag">
                                            {specialty}
                                        </span>
                                    ))}
                                </div>
                            )}
                            <Link to={`/team/${member.id}`} className="learn-more">
                                Learn More →
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MeetTheTeam;